import { useState } from "react";
import { useSelector } from "react-redux";
import { CopyToClipboardButton } from "../../Buttons/CopyToClipboardButton/CopyToClipboardButton";
import { ShareButton } from "../../Buttons/ShareButton/ShareButton";
import { Prompt, promptsList } from "../../../functions/promptsList";
import "./GuidePrompts.css";

interface PromptProps {
  alpha2Code?: string;
  alpha3Code?: string;
  category: string;
  name: string;
  promp: string;
  text: string;
}

interface GuidePromptsProps {
  onClose: () => void;
}

export const GuidePrompts = ({ onClose }: GuidePromptsProps) => {
  const [selectedPrompt, setSelectedPrompt] = useState<Prompt | null>(null);

  let templates = useSelector((state: any) => state.guidePrompsSearcher.value);
  const onCardClick = (prompt: PromptProps) => {
    setSelectedPrompt(prompt);
  };

  return (
    <>
      <div className="prompt-list">
        {templates.map((item: any) => (
          <div className="prompt-list__card" onClick={() => onCardClick(item)}>
            <div className="prompt-list__card--content">
              <span className="prompt-list__card--title">{item.content}</span>
              <span className="badge">{item.category}</span>
            </div>
            <div className="prompt-list__card--actions">
              <CopyToClipboardButton textToCopy={item.content} onClose={onClose} />
              <ShareButton promptToShare={item.content} onClose={onClose} />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
